// Viewport-state (zoom/pan) los van schema-data — bewust gesplitst van
// UmlSchemaEngine (SRP, zie design V1 punt 5). Geen persistente node-geometrie
// hier, puur canvas-transform.
class UmlViewportEngine {
  constructor() {
    this.scale = 1;
    this.panX = 0;
    this.panY = 0;
    this.minScale = 0.25;
    this.maxScale = 2;
    this.listeners = [];
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return function unsubscribe() {
      this.listeners = this.listeners.filter(function filterOutListener(listener) {
        return listener !== callback;
      });
    }.bind(this);
  }

  notify() {
    this.listeners.forEach(function callListener(listener) {
      listener();
    });
  }

  pan(dx, dy) {
    this.panX += dx;
    this.panY += dy;
    this.notify();
  }

  zoomAt(cursorX, cursorY, delta) {
    const prevScale = this.scale;
    const nextScale = clampScale(prevScale + delta, this.minScale, this.maxScale);
    if (nextScale === prevScale) {
      return;
    }
    // zoom-naar-cursor: punt onder de muis blijft vast
    const worldX = (cursorX - this.panX) / prevScale;
    const worldY = (cursorY - this.panY) / prevScale;
    this.scale = nextScale;
    this.panX = cursorX - worldX * nextScale;
    this.panY = cursorY - worldY * nextScale;
    this.notify();
  }

  reset() {
    this.scale = 1;
    this.panX = 0;
    this.panY = 0;
    this.notify();
  }

  // Absolute viewport restore (schema load, see UmlCanvasEngine.loadFromSchema)
  // — unlike pan()/zoomAt() which are RELATIVE to the current viewport, this
  // sets scale/pan directly from a saved value. Falls back to the same defaults
  // as the constructor when the schema has no saved viewport yet (older
  // schemas, or a brand-new/closed workspace) — undefined args are expected,
  // not an error case.
  restoreViewport(scale, panX, panY) {
    this.scale = clampScale(scale ?? 1, this.minScale, this.maxScale);
    this.panX = panX ?? 0;
    this.panY = panY ?? 0;
    this.notify();
  }
}

function clampScale(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

const umlViewportEngine = new UmlViewportEngine();
export default umlViewportEngine;
